export const enum TrackedTaskName {
  COMPRESS = "COMPRESS",
  DOWNLOAD = "DOWNLOAD",
  GENERATE_FILE = "GENERATE_FILE",
  FETCH = "FETCH",
  MERGE_PDF = "MERGE_PDF",
  PLOT_PDF = "PLOT_PDF",
  RASTERIZE_PDF = "RASTERIZE_PDF",
  SPLIT_PDF = "SPLIT_PDF",
  UPLOAD = "UPLOAD",
}
